import { render } from "./Attributions.vue?vue&type=template&id=47c70d85&scoped=true"
import script from "./Attributions.vue?vue&type=script&lang=js"
export * from "./Attributions.vue?vue&type=script&lang=js"

import "./Attributions.vue?vue&type=style&index=0&id=47c70d85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c70d85"]])

export default __exports__